import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FaGreaterThan, FaLessThan, FaSearch } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import ReleaseHeader from "./components/ReleaseHeader";
import "./components/ReleaseReport.css";
import Spinner from "../Spin/Spinner";
import DataTable from "../../components/common/DataTable/DataTable";
import DateCell from "../../components/common/TableCells/DateCell";
import { getRRReleaseReport } from "../../config/LiveApi";
import { IoReload } from "react-icons/io5";

function RollingReserveReleaseReport() {
  const token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);

  const [loading, setLoading] = useState(true);
  const [reportData, setReportData] = useState(null);
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [appliedOrderId, setAppliedOrderId] = useState("");

  const requiresMerchant =
    role === "super" || role === "operation" || role === "subSuper";
  const merchantNotSelected = requiresMerchant && !selectedMerchant;

  const fetchReport = async (pageNo, start, end, userId, orderId) => {
    setLoading(true);
    try {
      const response = await getRRReleaseReport(
        token,
        pageNo,
        start,
        end,
        userId,
        orderId,
      );
      setReportData(response);
    } catch (error) {
      console.error("Error fetching RR release report:", error.message);
      setReportData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!startDate || !endDate) return;
    if (merchantNotSelected) {
      setReportData(null);
      setLoading(false);
      return;
    }
    fetchReport(
      page,
      startDate,
      endDate,
      selectedMerchant?.value,
      appliedOrderId,
    );
  }, [page, startDate, endDate, selectedMerchant, appliedOrderId]);

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    setPage(1);
  };

  const handleMerchantChange = (merchant) => {
    setSelectedMerchant(merchant);
    setPage(1);
  };

  const handleSearch = () => {
    const trimmed = searchText.trim();
    if (!trimmed) return;
    setAppliedOrderId(trimmed);
    setPage(1);
  };

  const handleClearSearch = () => {
    setSearchText("");
    if (appliedOrderId) {
      setAppliedOrderId("");
      setPage(1);
    }
  };

  const columns = [];

  if (role === "super" || role === "operation" || role === "subSuper") {
    columns.push({
      key: "alias",
      header: "Business Name",
      wrapCell: true,
      render: (row) => row.alias || "N/A",
    });
  }

  columns.push(
    {
      key: "orderId",
      header: "Order Id",
      wrapCell: true,
      render: (row) => row.orderId || "-",
    },
    {
      key: "amount",
      header: "Amount (₹)",
      render: (row) => Number(row.amount || 0).toFixed(2),
    },
    {
      key: "createdAt",
      header: "Transaction Date",
      render: (row) => <DateCell date={row.createdAt} />,
    },
    {
      key: "updatedAt",
      header: "Release Date",
      render: (row) => <DateCell date={row.updatedAt} />,
    },
    {
      key: "status",
      header: "Status",
      render: (row) => (
        <p
          className={
            row.status
              ? "rr-release-status-released"
              : "rr-release-status-pending"
          }
        >
          {row.status ? "RELEASED" : "PENDING"}
        </p>
      ),
    },
  );

  const transactionDetail = reportData?.transactionDetail || [];
  const totalTxn = reportData?.totalTxn || 0;
  const totalPages = reportData?.totalPages || 0;
  const perPage = reportData?.perPage || 50;
    const reloadfunction = () => {
    window.location.reload();
  };

  return (
    <div>
      <ReleaseHeader
        onDateChange={handleDateChange}
        selectedMerchant={selectedMerchant}
        setSelectedMerchant={handleMerchantChange}
      />

      {merchantNotSelected ? (
        <div className="rr-release-select-merchant">
          Please select a merchant to view report
        </div>
      ) : (
        <>
      <div className="rr-release-cards">
        <div className="rr-release-card">
          <p className="rr-release-card-label">Total Transactions</p>
          <p className="rr-release-card-value">{totalTxn}</p>
          <p className="rr-release-card-sub blue">released records</p>
        </div>
        <div className="rr-release-card">
          <p className="rr-release-card-label">Total Amount</p>
          <p className="rr-release-card-value">
            ₹ {reportData?.totalAmount || "0.00"}
          </p>
         <p className="rr-release-card-sub blue">released amount</p>
        </div>
        {/* <div className="rr-release-card">
          <p className="rr-release-card-label">Pages</p>
          <p className="rr-release-card-value">{totalPages}</p>
          <p className="rr-release-card-sub orange">{perPage} per page</p>
        </div> */}
      </div>

      <div className="rr-release-table-section">
        {loading ? (
          <Spinner />
        ) : (
          <div className="rr-release-table-wrapper">
            <div className="rr-release-searchbar">
              <div className="rr-release-search-input">
                <FaSearch className="rr-release-search-icon" />
                <input
                  type="text"
                  placeholder="Search by Order Id..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                />
                {searchText && (
                  <IoMdClose
                    className="rr-release-search-clear"
                    onClick={handleClearSearch}
                  />
                )}
              </div>
              <button className="rr-release-search-btn" onClick={handleSearch}>
                Search
              </button>
              <button className="rr-release-search-btn" onClick={() => reloadfunction()}>
                        <IoReload />
            </button>
              {appliedOrderId && (
                <p className="rr-release-search-note">
                  Showing results for Order Id:{" "}
                  <span>{appliedOrderId}</span>
                </p>
              )}
            </div>

            <DataTable
              columns={columns}
              data={transactionDetail}
              emptyMessage="No Rolling Reserve Release Data Found"
            />

            <div className="rr-release-footer">
              <p className="rr-release-showing">
                Showing {transactionDetail.length} of {totalTxn} records
              </p>

              <div className="rr-release-pagination">
                <button
                  className="rr-release-page-btn"
                  disabled={page === 1}
                  onClick={() => setPage(page - 1)}
                >
                  <FaLessThan size={10} /> Prev
                </button>
                <span className="rr-release-page-current">{page}</span>
                <button
                  className="rr-release-page-btn"
                  disabled={page >= totalPages}
                  onClick={() => setPage(page + 1)}
                >
                  Next <FaGreaterThan size={10} />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
        </>
      )}
    </div>
  );
}

export default RollingReserveReleaseReport;
